<template>
  <div class="c-searchBottomSeo">
    <div
      class="c-footerTextWrapper"
      v-if="!seo.isTrendKeywordPage && seo.footerText && isFirstPage"
      ref="footerText"
    >
      <div
        class="c-footerText js_c-footerText"
        :class="{ 'c-footerText-folded': !footerTextExpanded }"
        v-html="seo.footerText"
      ></div>
      <a
        class="c-footerTextWrapper_expandButton"
        :class="{ 'c-footerTextWrapper_expandButton-folded': !footerTextExpanded }"
        @click="toggleFooterTextExpanded"
      >
        {{ footerTextExpanded ? '閉じる' : 'すべて見る' }}
        <coconala-icon
          :name="footerTextExpanded ? 'chevron-up': 'chevron-down'"
          size="10px"
        />
      </a>
    </div>
    <div
      class="c-trendKeywordsWrapper"
      v-if="isTrendKeywordsList"
      ref="trendKeywords"
    >
      <div
        class="c-trendKeywords js_c-trendKeywords"
        :class="{ 'c-trendKeywords-folded': !trendKeywordsExpanded }"
      >
        <h2 class="c-trendKeywords_head">
          <span v-if="seo.categoryName && !seo.isTrendKeywordPage">{{ seo.categoryName }}の</span>注目の検索キーワード
        </h2>
        <ul class="c-trendKeywords_list">
          <li
            class="c-trendKeywords_item"
            v-for="item in seo.trendKeywordsList"
            :key="item.path"
          >
            <NuxtLink :to="addQueryToUrlIfBusinessPreview(item.path)">{{ item.keywords }}</NuxtLink>
          </li>
        </ul>
      </div>
      <a
        class="c-trendKeywordsWrapper_expandButton"
        @click="toggleTrendKeywordsExpanded"
        v-if="isSP || isTB"
      >
        {{ trendKeywordsExpanded ? '閉じる' : 'すべて見る' }}
        <coconala-icon
          :name="trendKeywordsExpanded ? 'chevron-up': 'chevron-down'"
          size="10px"
        />
      </a>
    </div>
  </div>
</template>

<script>
import businessMixin from '~/mixins/pages/business-mixin'

import { mapGetters } from 'vuex'

// スクロール時間を0msに設定するとデフォルトの500msの速度になってしまったため、1msを設定している
const SCROLL_DURATION = 1

export default {
  name: 'ServiceSearchBottomSeo',
  mixins: [businessMixin],
  props: {
    seo: {
      type: Object
    },
    isFirstPage: {
      type: Boolean,
      default: true
    },
    currentCategoryTypeId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      footerTextExpanded: true,
      trendKeywordsExpanded: true
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    isTrendKeywordsList() {
      return this.seo.trendKeywordsList.length && !this.seo.isTagPage && !this.currentCategoryTypeId
    }
  },
  methods: {
    toggleFooterTextExpanded() {
      this.footerTextExpanded = !this.footerTextExpanded
      if (!this.footerTextExpanded) {
        this.$scrollTo(this.$refs.footerText, SCROLL_DURATION, {
          offset: -20 - this.$store.state.ui.fixedHeaderHeight
        })
      }
    },
    toggleTrendKeywordsExpanded() {
      this.trendKeywordsExpanded = !this.trendKeywordsExpanded
      if (!this.trendKeywordsExpanded) {
        this.$scrollTo(this.$refs.trendKeywords, SCROLL_DURATION, {
          offset: -20 - this.$store.state.ui.fixedHeaderHeight
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-footerTextWrapper {
  &_expandButton {
    position: relative;
    display: block;
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    &-folded {
      &::before {
        position: absolute;
        top: -20px;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 20px;
        background: linear-gradient(rgba(255, 255, 255, 0) 0, $color-white 20px);
        content: '';
      }
    }
  }
}
// DBから取得したhtmlに対してのCSS適用
.c-footerText {
  &-folded {
    overflow: hidden;
    max-height: 168px;
  }
  /deep/ .content-title {
    margin-top: 40px;
    margin-bottom: 16px;
    strong {
      color: $color-gray-900;
      font-size: 20px;
    }
  }
  /deep/ p {
    margin: 0;
    font-size: 13px;
  }
  /deep/ a {
    @include link-effect;
  }
}
.c-trendKeywords {
  margin-top: 40px;
  &_head {
    color: $color-font-base;
    font-weight: bold;
    font-size: 20px;
  }
  &_list {
    margin-top: 8px;
    padding: 12px 4px;
    border: 1px solid $color-gray-200;
    border-radius: 3px;
  }
  &_item {
    display: inline-block;
    padding: 0 16px;
    border-right: 1px solid $color-gray-200;
    font-size: 12px;
    line-height: 18px;
    a {
      @include link-effect;
    }
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-footerTextWrapper {
    padding: 0 10px;
    &_expandButton {
      font-size: 12px;
    }
  }
  .c-footerText {
    &-folded {
      max-height: 157px;
    }
    /deep/ .content-title {
      strong {
        font-size: 16px;
      }
    }
  }
  .c-trendKeywordsWrapper {
    &_expandButton {
      position: relative;
      display: block;
      text-align: center;
      font-size: 12px;
      line-height: 40px;
    }
  }
  .c-trendKeywords {
    margin-top: 40px;
    padding: 0 2px;
    width: 100%;
    &-folded {
      overflow: hidden;
      max-height: 56px;
    }
    &_head {
      padding: 0 8px;
      font-size: 16px;
    }
    &_list {
      padding: 0;
      border: 0;
    }
    &_item {
      padding: 0 8px;
      font-size: 10px;
    }
  }
}
</style>
